export default "/apps/maps/img/throbber.gif";